import { render, staticRenderFns } from "./CustomerBetreuerFilter.vue?vue&type=template&id=45630abc&scoped=true"
import script from "./CustomerBetreuerFilter.vue?vue&type=script&lang=ts"
export * from "./CustomerBetreuerFilter.vue?vue&type=script&lang=ts"
import style0 from "./CustomerBetreuerFilter.vue?vue&type=style&index=0&id=45630abc&prod&lang=scss&scoped=true"
import style1 from "./CustomerBetreuerFilter.vue?vue&type=style&index=1&id=45630abc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45630abc",
  null
  
)

export default component.exports